import { Box, Button, Card } from "@mui/material";
import React, { useEffect } from "react";
import { useAppDispatch, useAppSelector } from "../redux/hooks";
import { Navigate, useNavigate, useParams } from "react-router-dom";
import ResponseListData from "../components/FormBuilder/subcomponents/ResponseListData";
import Navbar from "../components/Navbar";
import { getAllResponses } from "../redux/entities/formBuilderEntity";

const ResponseListPage = () => {
  const navigate = useNavigate();
  const { formId } = useParams();
  const listData = useAppSelector(
    (state) => 
      state.entities.formBuilder.getAllResponses
  // console.log("tijare",state)
  );
  console.log("listData",listData);
  
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(getAllResponses(formId));
  }, [formId, dispatch]);

  return (
    <>
      <Navbar />
      {listData?.totalCount > 0 ? (
        <div className="d-flex mt-5 flex-column align-items-center justify-content-center">
          <h3>User Response List</h3>
          {/* <div className="form-templates row mt-1"></div> */}
          <Box sx={{ width: "100%" }}>
            <Card sx={{ p: 2 }}>
              <ResponseListData data={listData} />
            </Card>
          </Box>
        </div>
      ) : (
        <>
        <h3 className="d-flex mt-5 flex-column align-items-center justify-content-center">
          Response Not Found
        </h3>
        <div style={{display:"flex",justifyContent:"flex-end",marginRight:"100px"}}>
        <Button
          variant="outlined"
          onClick={() => navigate("/publish-template")}
          sx={{ marginLeft: "20px",backgroundColor:"white",color:"light blue" }}
        >
          Back
        </Button>
        </div>
        </>
      )}
    </>
  );
};

export default ResponseListPage;
